import { Component, OnInit, Output, EventEmitter, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

import { RxComponent } from 'app/core/components/common/rx.component';

export interface ListTab {
    name: string;
}

export interface ListSearchEvent {
    filter: string;
    selectedTab: ListTab;
}

export interface ListItem<T = null> {
    id: string;
    label: string;
    logo: string;
    data?: T;
}

@Component({
    selector: 'itpx-multitab-selection-list',
    templateUrl: './multitab-selection-list.component.html',
    styleUrls: ['./multitab-selection-list.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultitabSelectionList<T = null> extends RxComponent implements OnInit {

    @Input() tabs: ListTab[] = [];
    @Input() selectedTabIndex: number = 0;
    @Input() searchResults: ListItem<T>[] = [];
    @Input() listName: string = 'Items';
    @Input() selectedItems : ListItem<T>[] = [];

    @Output() search: EventEmitter<ListSearchEvent> = new EventEmitter();;

    searchForm: FormGroup;

    constructor(
        private fb: FormBuilder,
    ) {
        super();
    }

    ngOnInit() {
        super.ngOnInit();
        this.initializeForm();
    }

    searchForItems() {
        this.search.emit({
            filter: this.searchForm.get('search').value,
            selectedTab: this.tabs[this.selectedTabIndex],
        });
    }

    toggleItem(item: ListItem<T>) {
        this.isItemSelected(item)
            ? this.unselectItem(item)
            : this.selectItem(item)
    }

    unselectItem(item: ListItem<T>) {
        this.selectedItems = this.selectedItems.filter((i: ListItem<T>) => i.id !== item.id);
    }

    isItemSelected(item: ListItem<T>): boolean {
        return this.selectedItems.findIndex((i: ListItem<T>) => i.id === item.id) !== -1;
    }

    selectItem(item: ListItem<T>) {
        this.selectedItems = [...this.selectedItems, item];
    }

    private initializeForm() {
        this.searchForm = this.fb.group({
            search: ['']
        });
        this.searchForItems();
        this.searchForm.get('search').valueChanges
            .bindToLifecycle(this)
            .debounceTime(1000)
            .subscribe(_ => {
                this.searchForItems();
            });
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/multitab-selection-list/multitab-selection-list.component.ts